import imguser from '../../../../assets/images/user.png'
import moment from 'moment';

export const ColumnCreative_Work_Requests = (translate, handleEdit, handleEvaluationDetails, langLocal) => {
    const getBackgroundColor = (evaluation) => {
        switch (evaluation) {
            case 'accepted':
                return 'excellent';
            case 'unaccepted':
                return 'satisfactory';
            case 'reject':
                return 'poor';
            default:
                return '#FFFFFF';
        }
    };
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('name')}</span>, sortable: true, width: '150px',
            cell: (row) => (
                <div className='div_img_table' >
                    <img className={langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} src={imguser} />
                    {
                        row.visitor && (
                            <span>{row.visitor.first_name} {row.visitor.last_name}</span>
                        )
                    }
                </div>
            )
        },
        {
            name: <span className="color_spann">{translate('phone')}</span>, sortable: true, width: '150px',
            cell: (row) => (
                <>
                    {
                        row.visitor && (
                            <span>{row.visitor.phone_number}</span>
                        )
                    }
                </>
            )
        },
        {
            name: <span className="color_spann">{translate('email')}</span>, sortable: true, width: '180px',
            cell: (row) => (
                <>
                    {
                        row.visitor && (
                            <span>{row.visitor.email}</span>
                        )
                    }
                </>
            )
        },
        {
            name: <span className="color_spann">{translate('script_name')}</span>,
            cell: (row) => (
                <span>{row['title']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('script_type')}</span>,
            cell: (row) => (
                <span>{row.workType.name}</span>
            )
        },
        {
            name: <span className="color_spann span_status">{translate('status')}</span>,
            width: '150px',
            cell: (row) => (
                <span style={{ minWidth: '60px' }} className={`div_status ${getBackgroundColor(row.status)}`} >
                    {row.status}
                </span>
            )
        },
        {
            name: <span className="color_spann">{translate('episodes_count')}</span>,
            cell: (row) => (
                <>
                    {
                        row.episodes_count ? (
                            <span>{row['episodes_count']}</span>
                        ) : <span>-</span>
                    }
                </>

            )
        },
        {
            name: <span className="color_spann">{translate('film_duration')}</span>,
            cell: (row) => (
                <>
                    {
                        row.duration_minutes ? (
                            <span>{row['duration_minutes']}</span>
                        ) : <span>-</span>
                    }
                </>

            )
        },
        {
            name: <span className="color_spann">{translate('evaluation_avg')}</span>,
            cell: (row) => (
                <>
                    {
                        row.averageDegree ? (
                            <span>{row['averageDegree']}</span>
                        ) : <span>-</span>
                    }

                </>
            )
        },
        {
            name: <span className="color_spann">{translate('created_at')}</span>,
            cell: (row) => (
                <span>{moment(row['created_at']).format("YYYY-MM-DD")}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('actions')}</span>, width: "200px",
            cell: (row) => (
                <div className='btns_table'   >
                    <button className='back-btn-green' onClick={(e) => handleEdit(e, row)} >
                        <i className='fa-solid fa-list-check icon_evaluation' ></i>
                        <span>{translate('request')}</span>
                    </button>
                    <button className='back-btn-blue' onClick={(e) => handleEvaluationDetails(e, row)} >
                        <i className='fa-solid fa-circle-info icon_details'  ></i>
                        <span>{translate('details')}</span>
                    </button>
                </div>


            )
        }
    ]
    return {
        columns
    }
}

{/*<OptionsIcon warning={warning} row={row} setopenEdit={setopenEdit} handleEdit={handleEdit} />*/ }